import { render } from "./zonghe-yeji.vue?vue&type=template&id=b5b36234&scoped=true"
import script from "./zonghe-yeji.vue?vue&type=script&lang=js"
export * from "./zonghe-yeji.vue?vue&type=script&lang=js"

import "./zonghe-yeji.vue?vue&type=style&index=0&id=b5b36234&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b36234"]])

export default __exports__